export enum MapTypeStatus {
    ROADMAP = 'roadmap',
    HYBRID = 'hybrid'
}